import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { TASK_OPERATION_TIMEOUT_MS } from '#pplx/frontend/apps/ask/queries/tasks-queries/constants.js';
import { tasksClient } from '#pplx_generated/typespec/rest/tasks/client.js';
export const pasteShortcut = async ({ copyToken, reason, headers, }) => {
    const { data, error, response } = await tasksClient.GET('/rest/tasks/shortcuts/paste/{copy_token}', reason, {
        params: {
            path: {
                copy_token: copyToken,
            },
        },
        headers,
        timeoutMs: TASK_OPERATION_TIMEOUT_MS,
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
//# sourceMappingURL=pasteShortcut.js.map